/**
 * Display-only label normalization for compact card UIs across all tool
 * forms. Splits "Bermudagrass" → "Bermuda grass" so the label wraps at a
 * natural word boundary on narrow viewports instead of breaking
 * mid-character. Engine submit names stay untouched.
 */
export function grassDisplayName(name: string): string {
  switch (name) {
    case "Bermudagrass":
      return "Bermuda grass"
    case "Bahiagrass":
      return "Bahia grass"
    case "Ryegrass":
      return "Rye grass"
    case "Kikuyugrass":
      return "Kikuyu grass"
    case "Mixed Cool-Season Blend":
      return "Cool-Season Mix"
    default:
      return name
  }
}
